import React from "react";

import "assets/css/skills.css";
import astronaut from 'assets/img/landing/home/Be_A_Part-03.svg';
import astro1 from 'assets/img/landing/home/Astronaut-01.png';
import skillwavet from 'assets/img/landing/home/waves/skillwavetop.png'
import skillwaveb from 'assets/img/landing/home/waves/skillwavebtm.png'
//import Footer from './footer.js';
import bg from 'assets/img/landing/home/adhyanshala-01.jpg';
function Home() {

    return (
        <>
            <div className="hero">
                <div className="container"  data-aos="zoom-in" style={{ marginTop: '3.5rem' }}>
                    <div className="row mt-5">
                        <div className="col-md-2 mt-3">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/wloilxuq.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-3">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/qhgmphtg.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-3">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/gqdnbnwt.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-3">
                            <div className="feature-card text-center">

                                <lord-icon
                                    src="https://cdn.lordicon.com/soseozvi.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-3">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/wxnxiano.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-3">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/zpxybbhl.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-2 mt-3">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/jjjmlddk.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-8 mt-4">
                            <div className="main-text section-title text-center" data-aos="fade-up" data-aos-delay="0.1s">
                                <h1 className="text-black font">Skill Development</h1>
                                <p>
                                   Learn about the skills that we plan to induce into rural population
                                </p>
                            </div>
                        </div>
                        <div className="col-md-2 mt-3 one">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/gxulgxck.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-2 mt-3  one">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/qhgmphtg.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-3 one">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/fgkmrslx.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-4 ">
                            <img src={bg} className="ml-5 adhyanshala-logo" style={{ marginTop: '-40px' }} width="70%" alt="d" />
                        </div>
                        <div className="col-md-2 mt-1">
                            <div className="feature-card text-center">

                                <lord-icon
                                    src="https://cdn.lordicon.com/fqrjldna.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-1">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/vixtkkbk.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-1">
                        <div className="col-md-2 mt-1">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/ngcezuqf.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-1">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/qhviklyi.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-1">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/gqzfzudq.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-1">
                            <div className="feature-card text-center">

                                <lord-icon
                                    src="https://cdn.lordicon.com/hbjlznlo.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-1">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/xqnbvely.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                        <div className="col-md-2 mt-1">
                            <div className="feature-card text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/tvyxmjyo.json"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '100px', height: '100px' }}>
                                </lord-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container" data-aos="zoom-in" style={{marginTop: '8rem'}}>
                <div className="main-text section-title mt-5 mb-3 text-center" data-aos="fade-up" data-aos-delay="0.1s">
                    <h1 className="text-black" style={{fontSuze:'40px'}}>Overview</h1>
                   
                </div>
                <div className="row mt-5">
                    <div className="col-md-5">
                        <div className="d-flex justify-content-center align-middle">
                        <lottie-player src="https://assets4.lottiefiles.com/packages/lf20_ojjrkacr.json"  background="transparent"  speed="1"  style={{"width": "300px", "height": "300px"}}  loop  autoplay></lottie-player>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <p className="mt-5 text-start px-sm-3 p-md-0">
                           Adhyanshala will allow all students to learn new skills and become more productive individuals and job-ready. We will have a lot of specially curated courses from global teachers which the students will be able to access anywhere, anytime. These courses will mainly be catered to anyone wanting to learn, we will also try in the future for multilingual courses to cater to a wider crowd.
                        </p>
                        

                    </div>
                </div>
            </div> 

            <div className="container" data-aos="zoom-in" style={{marginTop: '8rem'}}>
                <div className="main-text section-title mt-5 mb-3 text-center" data-aos="fade-up" data-aos-delay="0.1s">
                    <h1 className="text-black"> Types Of Courses : </h1>
                </div>
                <div className="row">
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center aligin-items-center">
                                    <div className="service-card py-2 px-3 mt-4">
                                        <div className="service-icon text-center">
                                                 <lord-icon
                                    src="https://cdn.lordicon.com/soseozvi.json"
                                    className="center"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '60px', height: '60px' }}>
                                </lord-icon>
                                        </div>
                                       
                                        
                                         <h2 className="text-center">Online live</h2>

                                        <p className="text-center">These will be online courses taken by the best teachers in real-time. Mainly for a better doubt-solving experience for students.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 mt-md-5 mt-0">

                                <div className="d-flex justify-content-center aligin-items-center">
                                    <div className="service-card py-2 px-3 mt-4">
                                        <div className="service-icon text-center">
                                            <lord-icon
                                    src="https://cdn.lordicon.com/tclnsjgx.json"
                                    className="center"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '60px', height: '60px' }}>
                                </lord-icon>
                                        </div>
                                        <h2 className="text-center">Online videos</h2>
                                        
                                        <p className="text-center">These will be well-structured specially curated online recorded courses. Each of them will be covering the whole topic.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center aligin-items-center">
                                    <div className="service-card py-2 px-3 mt-4">
                                        <div className="service-icon text-center">
                                             <lord-icon
                                    src="https://cdn.lordicon.com/zpxybbhl.json"
                                    className="center"
                                    trigger="loop"
                                    colors="primary:#000033,secondary:#000033"
                                    style={{ width: '60px', height: '60px' }}>
                                </lord-icon>
                                        </div>
                                        <h2 className="text-center">Offline</h2>
                                       
                                        <p className="text-center">These will involve in-person teaching, the good old way of learning. Experienced teachers will take various classes.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
          
                <img src={skillwavet} width="100%" style={{marginTop:"8rem"}} alt='img' />
            <div className="container-fluid" style={{ "background": "#000033" }} >
                <div className="row">
                    <div className="col-12">
                        <h1 className="text-white text-center">“learning is not the product of teaching,<br/> learning is the product of the activity of learners”</h1>
                    </div>
                </div>

            </div>
            <img src={skillwaveb} width="100%" className="mb-5" alt='img' />
        

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-md-6 order-2 order-md-1" data-aos="fade-right">
                            <div className="row">
                                <div className="col-md-6 my-auto">
                                    <div className="statergy-card px-3 py-2 mt-5 mt-lg-0">
                                        <div className="icon-box box-1 text-center">
                                            <lord-icon
    src="https://cdn.lordicon.com/anihkfxp.json"
    trigger="loop"
    colors="primary:#000033,secondary:#000033"
    stroke="48"
    scale="46"
    style={{ height:'50px' ,width:'50px'}}>
</lord-icon>
                                        </div>
                                        <div className="text-center">
                                            <h2 className="heading2">Web Development</h2>
                                            <p>learn web development from our portal.</p>
                                        </div>
                                    </div>
                                    <div className="statergy-card px-3 py-2 mt-5">
                                        <div className="icon-box box-2 text-center">
                                           <lord-icon
    src="https://cdn.lordicon.com/gqdnbnwt.json"
    trigger="loop"
    colors="primary:#000033,secondary:#000033"
    stroke="48"
    scale="46"
    style={{ height:'50px' ,width:'50px'}}>
</lord-icon>
                                        </div>
                                        <div className="text-center">
                                            <h2>Mathematics</h2>
                                            <p>Best of maths, available in your hands.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 my-auto">
                                    <div className="statergy-card px-3 py-2 mt-5 mt-lg-0">
                                        <div className="icon-box box-3 text-center">
                                            <lord-icon
    src="https://cdn.lordicon.com/hbjlznlo.json"
    trigger="loop"
    colors="primary:#000033,secondary:#000033"
    
    style={{ height:'50px' ,width:'50px'}}>
</lord-icon>
                                        </div>
                                        <div className="text-center">
                                            <h2>Science</h2>
                                            <p>learn the latest of science through the courses.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 order-1 order-md-2" data-aos="fade-left">
                            <div className="d-flex justify-content-center">
                                <img src={astronaut} width="75%" alt="s" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-5 mb-5">
                    <div className="row">
                        <div className="col-md-6" data-aos="fade-left">
                            <div className="align-middle justify-content-center">
                                <img src={astro1} width="75%" alt="s" />
                            </div>
                        </div>
                        <div className="col-md-6" data-aos="fade-right">
                            <div className="row">

                                <div className="col-md-6 my-auto">
                                    <div className="statergy-card px-3 py-2 mt-5 mt-lg-0">
                                        <div className="icon-box box-3 text-center">
                                             <lord-icon
    src="https://cdn.lordicon.com/vlupvdhl.json"
    trigger="loop"
    colors="primary:#000033,secondary:#000033"
    stroke="48"
    scale="46"
    style={{ height:'50px' ,width:'50px'}}>
</lord-icon>
                                        </div>
                                        <div className="text-center">
                                            <h2>Artificial Intelligence</h2>
                                            <p> Use your intelligence to learn the artificial one.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 my-auto">
                                    <div className="statergy-card px-3 py-2 mt-5 mt-lg-0">
                                        <div className="icon-box box-1 text-center">
                                            <lord-icon
    src="https://cdn.lordicon.com/wloilxuq.json"
    trigger="loop"
    colors="primary:#000033,secondary:#000033"
    stroke="48"
    scale="46"
    style={{ height:'50px' ,width:'50px'}}>
</lord-icon>
                                        </div>
                                        <div className="text-center">
                                            <h2> Designing</h2>
                                            <p> Learn graphic designing on adhyanshala for free.</p>
                                        </div>
                                    </div>
                                    <div className="statergy-card px-3 py-2 mt-5">
                                        <div className="icon-box box-2 text-center">
                                             <lord-icon
    src="https://cdn.lordicon.com/zpxybbhl.json"
    trigger="loop"
    colors="primary:#000033,secondary:#000033"
    stroke="48"
    scale="46"
    style={{ height:'50px' ,width:'50px'}}>
</lord-icon>
                                        </div>
                                        <div className="text-center">
                                            <h2>English</h2>
                                            <p>learn spoken English and flaunt it to everyone with confidence.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            
            </div>
        </>
    );
}


export default Home;